import { BaseComponent } from '../../../../components/BaseComponent';
import styled from 'styled-components';
import Table from 'rc-table';
import React from 'react';
import { fixPriceFormat, formatCurrency } from '../../../../utils/string';
import PropTypes from 'prop-types';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import { CompanyProductCustomizationItemActions } from './CompanyProductCustomizationsAction';
import { FormField, FormFields } from '../../../../components/FormFields';
import { VBox } from '../../../../components/Box';
import { SearchSelect } from '../../../../components/SearchSelectComponent';
import { selectConfig } from '../../../Api/selectors';
import ModalComponent from '../../../../containers/App/Components/Modal/Modal';
import ButtonComponent from '../../../../containers/App/Components/Button/Button';

import styles from './CompanyProductCustomizationsTable.module.css';

const Container = styled.div`
  width: 100%;
  background: white;

  .basic-multi-select {
    width: 100%;
  }
`;

const CustomTable = styled(Table)`
  width: 100%;
  display: flex;
  flex-direction: column;
  font-size: 12px;

  .rc-table-container {
    width: 100%;
  }

  .rc-table-content table {
    width: 100%;
  }

  .rc-table-thead {
    background-color: #eff1f7;
    font-weight: 600;
    height: 52px;
    padding: 16px 0;
    margin-left: 8px;
    font-size: 14px;
  }

  .rc-table-footer {
    background-color: #eff1f7;
    font-weight: 600;
    height: 52px;
    padding: 0 16px;
    // margin-left: 8px;
    font-size: 14px;
  }

  td,
  th {
    padding: 8px 12px;
  }
`;

const ActionsContainer = styled.div`
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
`;

const IconWrapper = styled.div`
  color: ${props =>
    props?.color === 'darkgray' ? 'darkgray' : 'green' ? '#11ab79' : props?.color === 'orange' ? '#FC9629' : '#d50046'};
`;

const Wrap = styled.div`
  width: 100%;
  .basic-multi-select {
    width: 100%;
  }
`;

class CompanyProductCustomizationsTableComp extends BaseComponent {
  getColumns = () => {
    return [
      {
        title: this.lblStr('product.column.vehicle_purpose'),
        dataIndex: 'vehiclePurpose',
        key: 'vehiclePurpose',
        align: 'left',
      },
      {
        title: this.lblStr('product.create.purchase_price_excl_vat'),
        dataIndex: 'purchasePriceExclVat',
        key: 'purchasePriceExclVat',
        align: 'left',
        render(value) {
          return value !== null ? formatCurrency(value) : '';
        },
      },
      {
        title: this.lblStr('product.create.sales_price_excl_vat'),
        dataIndex: 'salesPriceExclVat',
        key: 'salesPriceExclVat',
        align: 'left',
        render(value) {
          return value !== null ? formatCurrency(value) : '';
        },
      },
      {
        title: this.lblStr('product.column.actions'),
        key: 'actions',
        dataIndex: 'actions',
        align: 'left',
        render(value) {
          return (
            <ActionsContainer>
              <IconWrapper color={'darkgray'}>
                <CompanyProductCustomizationItemActions product={value} />
              </IconWrapper>
            </ActionsContainer>
          );
        },
      },
    ];
  };

  getItems = () => {
    let items = [];
    this.props.product.companyCustomizations.forEach(item => {
      if (item.vehiclePurpose) item.name = null;
      if (!item.vehiclePurpose) item.vehiclePurpose = 'default';
      item.name = this.props.product.name;
      item.actions = item;
      items.push(item);
    });
    items = this.moveDefaultToFront(items);

    return items;
  };

  moveDefaultToFront(arr) {
    const defaultIndex = arr.findIndex(obj => obj.vehiclePurpose === 'default');

    if (defaultIndex > 0) {
      const [defaultObj] = arr.splice(defaultIndex, 1);
      arr.unshift(defaultObj);
    }

    return arr;
  }

  onClickEdit(record) {
    this.setState({ editRecord: record });
  }

  onCloseEdit() {
    this.setState({ editRecord: null });
  }

  onUpdateCustomization() {
    this.props.onUpdate(
      this.state.editRecord.id,
      {
        purchasePriceExclVat: this.sanitizeAmount(this.state.editRecord.purchasePriceExclVat),
        salesPriceExclVat: this.sanitizeAmount(this.state.editRecord.salesPriceExclVat),
      },
      this.onCloseEdit.bind(this),
    );
  }

  onPriceChanged(evt) {
    evt.persist();
    const name = evt.target.name;
    const value = evt.target.value;
    let stateKey = null;
    if (this.state.editRecord) stateKey = 'editRecord';
    if (this.state.addRecord) stateKey = 'addRecord';
    this.setState(prev => ({ ...prev, [stateKey]: { ...prev[stateKey], [name]: value } }));
  }

  renderCustomDetailsModal() {
    if (!this.state.editRecord) return '';

    return (
      <ModalComponent onClose={this.onCloseEdit.bind(this)} title={this.lbl(`companyProduct.customization.editTitle`)}>
        <VBox>
          <FormFields>
            <FormField label={this.lbl('product.column.vehicle_purpose')}>
              <input
                className="form-control"
                name="vehiclePuspose"
                value={this.state.editRecord.vehiclePurpose}
                type="text"
                disabled
              />
            </FormField>
            <FormField label={this.lbl('product.create.purchase_price_excl_vat')}>
              <input
                className="form-control"
                name="purchasePriceExclVat"
                value={this.state.editRecord.purchasePriceExclVat}
                onChange={this.onPriceChanged.bind(this)}
                type="text"
              />
            </FormField>
            <FormField label={this.lbl('product.create.sales_price_excl_vat')}>
              <input
                className="form-control"
                name="salesPriceExclVat"
                value={this.state.editRecord.salesPriceExclVat}
                onChange={this.onPriceChanged.bind(this)}
                type="text"
              />
            </FormField>
          </FormFields>
        </VBox>
        <div className={styles.buttonContainer}>
          <div className={styles.rowButtonsWrapper}>
            <ButtonComponent style={'ButtonSoftDelete'} onClick={this.onCloseEdit.bind(this)}>
              {this.lbl('cancel')}
            </ButtonComponent>
            <ButtonComponent
              style={'ButtonSoftEdit'}
              disabled={this.saveDisabled}
              onClick={this.onUpdateCustomization.bind(this)}
            >
              {this.lbl('confirm')}
            </ButtonComponent>
          </div>
        </div>
      </ModalComponent>
    );
  }

  get availableVehiclePurposes() {
    const fromConfig = (this.props.config?.configJSON?.vehicle_purposes ?? []).map(p => p.vehicle_purpose);
    const defaultPurposes = [
      'passenger',
      'commercial',
      'Trekker/Vrachtwagen',
      'BW >3500kg',
      'Oplegger',
      'Aanhangwagen',
      'Landbouw- of bosbouwtrekker',
      'Motorfiets' ,
      'Bromfiets',
      'Klein materieel binnenopslag per m2',
      'Klein/middelgroot materieel buitenopslag <6m2',
      'Groot & afwijkend materieel buitenopslag >6m2',
      'chassiscabine_less_3500',
      'chassiscabine_greater_3500',
      'motor',
      'oplegger',
      'aanhanger',
      
    ];

    // TODO refactor return only fromConfig after IDWE-2829 merged
    return fromConfig.length ? fromConfig : defaultPurposes;
  }

  get addedPurposes() {
    return this.props.product.companyCustomizations.map(c => c.vehiclePurpose);
  }

  get vehiclePurposesOptions() {
    return this.availableVehiclePurposes
      .filter(purpose => !this.addedPurposes.includes(purpose))
      .map(purpose => ({ value: purpose, label: purpose }));
  }

  setVehiclePurposeForNewRecord(evt) {
    const value = evt.value;
    this.setState(prev => ({ ...prev, addRecord: { ...prev.addRecord, vehiclePurpose: value } }));
  }

  onClickAdd() {
    this.setState({ addRecord: {} });
  }

  onCloseAdd() {
    this.setState({ addRecord: null });
  }

  onAddCustomization() {
    this.props.onAdd(
      {
        vehiclePurpose: this.state.addRecord.vehiclePurpose,
        purchasePriceExclVat: this.sanitizeAmount(this.state.addRecord.purchasePriceExclVat),
        salesPriceExclVat: this.sanitizeAmount(this.state.addRecord.salesPriceExclVat),
      },
      this.onCloseAdd.bind(this),
    );
  }

  sanitizeAmount(amount) {
    if (amount === '') return null;
    if (typeof amount === 'string') amount = amount.replaceAll(',', '.');
    return +fixPriceFormat(amount);
  }

  get confirmAddRecordDisabled() {
    return !this.state.addRecord.vehiclePurpose;
  }

  renderAddCustomModal() {
    if (!this.state.addRecord) return '';

    return (
      <ModalComponent onClose={this.onCloseAdd.bind(this)} title={this.lbl(`companyProduct.customization.editTitle`)}>
        <VBox>
          <FormField label={this.lbl('product.create.vehicle_purpose_type')}>
            <Wrap>
              <SearchSelect
                minWidth="100%"
                options={this.vehiclePurposesOptions}
                value={{ label: this.state.addRecord.vehiclePurpose }}
                onChange={this.setVehiclePurposeForNewRecord.bind(this)}
              />
            </Wrap>
          </FormField>
          <FormField label={this.lbl('product.create.purchase_price_excl_vat')}>
            <input
              className="form-control"
              name="purchasePriceExclVat"
              value={this.state.addRecord.purchasePriceExclVat}
              onChange={this.onPriceChanged.bind(this)}
              type="text"
            />
          </FormField>
          <FormField label={this.lbl('product.create.sales_price_excl_vat')}>
            <input
              className="form-control"
              name="salesPriceExclVat"
              value={this.state.addRecord.salesPriceExclVat}
              onChange={this.onPriceChanged.bind(this)}
              type="text"
            />
          </FormField>
        </VBox>

        <div className={styles.buttonContainer}>
          <div className={styles.rowButtonsWrapper}>
            <ButtonComponent style={'ButtonSoftDelete'} onClick={this.onCloseAdd.bind(this)}>
              {this.lbl('cancel')}
            </ButtonComponent>
            <ButtonComponent
              style={'ButtonSoftEdit'}
              onClick={this.onAddCustomization.bind(this)}
              disabled={this.confirmAddRecordDisabled}
            >
              {this.lbl('confirm')}
            </ButtonComponent>
          </div>
        </div>
      </ModalComponent>
    );
  }

  render() {
    const columns = this.getColumns();
    const data = this.getItems();

    return (
      <Container>
        <ButtonComponent style={'ButtonSoftAdd'} small onClick={this.onClickAdd.bind(this)}>
          +{this.lbl('add')}
        </ButtonComponent>
        <CustomTable
          columns={columns}
          data={data}
          scroll={{ x: window.innerWidth < 975 ? 975 : false }}
          emptyText="No products found by current filters"
          onRow={(record, index) => {
            return {
              onClick: () => this.onClickEdit(record),
            };
          }}
        />
        {this.renderCustomDetailsModal()}
        {this.renderAddCustomModal()}
      </Container>
    );
  }
}

CompanyProductCustomizationsTableComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
  onItemClick: PropTypes.func,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    config: selectConfig(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const CompanyProductCustomizationsTable = compose(
  withConnect,
  withRouter,
  injectIntl,
)(CompanyProductCustomizationsTableComp);
